import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const EternityRing = () => {
    return (
        <>
            <Container className='dfl_custome_container_staticpage'>
                <Row className='w-100 m-auto'>
                    <Col sm={12} md={12} lg={12} className="p-0">
                        <div className='dfl_wedding_eternity_ring_section clearfix eternity_ring_content'>
                            <Row>
                                <Col sm={12} md={7} lg={6} xl={6}>
                                    <div className='text-center'>
                                        <h2>Eternity Rings</h2>
                                        <p>Eternity rings symbolize ‘Forever’. These rings are the perfect way to show your partner you will be with them for eternity. Eternity rings are studded with gorgeous diamonds all around to complement your finger. The shine and sparkle will be a complement to your engagement ring.</p>
                                        <NavLink to="/jewelry/wedding-rings/Eternity">Shop Eternity rings</NavLink>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>

        </>
    )
}

export default EternityRing